module.exports = __webpack_public_path__ + "img/header-navigation-below-hyundai.78a4214c.png";